/* Paths */
import { generalPaths } from "common/data/routePaths";
import { lazy } from "react";

/*
Components
*/

const NotificationsLogs = lazy(() =>
  import("pages/General/Notifications/NotificationsLogs")
);

const NotificationSearchResults = lazy(() =>
  import("pages/Motors/FNOL/SearchResults/NotificationSearchResults")
);

const { notificationsLogs, dropdownNotifications } = generalPaths;

export const GeneralRoutes = [
  // Notifications Logs (for module)
  { path: notificationsLogs, component: NotificationsLogs },

  // Notifications Logs (for view all button in notifications dropdown)
  { path: dropdownNotifications, component: NotificationsLogs },
  // for clicking the notification
  {
    path: `${notificationsLogs}/search-results/:fnolNo`,
    component: NotificationSearchResults,
  },
];
